import NavBar from '@/HostApp/ui/components/Dojo2Vue/NavBar.vue';
import SideBar from '@/HostApp/ui/components/Dojo2Vue/SideBar.vue';
import Notifications from '@/HostApp/ui/components/Dojo2Vue/Notifications.vue';
import Impersonated from '@/HostApp/ui/components/Dojo2Vue/Impersonated.vue';
import NavBarAnonymous from '@/HostApp/ui/components/Dojo2Vue/NavBarAnonymous.vue';
import HelpCenterNode from '@/HostApp/ui/system/HelpCenterNode.vue';

const grid: LAYOUT.IGrid = {
		styles: {
			style: {
				height: '100vh',
				width: '100vw',
				gridTemplateAreas:
					"'header header header header'" +
					"'aside banner banner banner'" +
					"'aside viewport notifications helpcenter'",
				gridTemplateRows: '70px 30px calc(100vh - 100px)',
				gridTemplateColumns: '350px minmax(860px, 1fr) 0 0'
			},
			lg: {
				gridTemplateRows: '70px 30px calc(91vh - 100px)',
				gridTemplateColumns: '350px minmax(860px, calc(91vw - 350px)) 0 0'
			},
			xl: {
				gridTemplateRows: '70px 30px calc(69vh - 100px)',
				gridTemplateColumns: '350px minmax(860px, calc(69vw - 350px)) 0 0'
			}
		}
	},
	aside = {
		name: 'aside',
		component: SideBar,
		styles: {
			style: {
				overflow: 'hidden'
			}
		}
	},
	header = {
		name: 'header',
		component: NavBar as typeof NavBar | typeof NavBarAnonymous
	},
	banner = {
		name: 'banner',
		component: Impersonated
	},
	notifications = {
		name: 'notifications',
		component: Notifications
	},
	helpcenter = {
		name: 'helpcenter',
		component: HelpCenterNode,
		styles: {
			style: {
				zIndex: '1000'
			}
		}
	};

export function createDojoTemplate(serverProps: APS.IServerProps): LAYOUT.ILayoutTemplate {
	const styles = grid.styles as LAYOUT.IGridItemStyles;
	const items: Array<LAYOUT.IGridItem> = [helpcenter, notifications, header, aside, banner];
	const { isXSClientType, isAnonymousContext, isShowLeftMenu } = serverProps;
	const { impersonatedWarning } = serverProps.breadcrumbs || {};

	if (isXSClientType) {
		styles.style = {
			gridTemplateAreas: "'header'" + "'title'" + "'viewport'",
			gridTemplateRows: '50px min-content 1fr',
			gridTemplateColumns: '1fr'
		};
	} else {
		if (!impersonatedWarning) {
			(styles.style as Partial<CSSStyleDeclaration>).gridTemplateRows = '70px 0 calc(100vh - 70px)';
			(styles.lg as Partial<CSSStyleDeclaration>).gridTemplateRows = '70px 0 calc(91vh - 70px)';
			(styles.xl as Partial<CSSStyleDeclaration>).gridTemplateRows = '70px 0 calc(69vh - 70px)';
		}
	}

	if (!isShowLeftMenu && !isXSClientType) {
		(styles.style as Partial<CSSStyleDeclaration>).gridTemplateColumns = 'min-content minmax(860px, 1fr) 0 0';
		(styles.lg as Partial<CSSStyleDeclaration>).gridTemplateColumns =
			'min-content minmax(860px, calc(91vw - 350px)) 0 0';
		(styles.xl as Partial<CSSStyleDeclaration>).gridTemplateColumns =
			'min-content minmax(860px, calc(69vw - 350px)) 0 0';
	}

	if (isAnonymousContext) {
		header.component = NavBarAnonymous;
	}

	return {
		grid,
		items
	};
}
